import { getFolderListEpic } from './epics';

const dataEpics = [getFolderListEpic];

export default dataEpics;
